import { Dialog } from '@material-ui/core';
import React, { useState, useMemo } from 'react';
import CommentMessage from "./CommentMessage";
import { Divider } from "@material-ui/core";
import { useDispatch, useSelector } from 'react-redux';
import InputComment from "./InputComment";
import styled from 'styled-components/macro';
import CustomButton from "components/CustomInput/Button";
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import LaunchIcon from '@material-ui/icons/Launch';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { commentStatusEnum } from 'constants/globalEnum';
import CustomTextField from "components/Input/CustomTextField";
import { UPDATE_DRAFT_COMMENT } from 'store/key';
import {
    APPLICANT,
    CCO,
    CLUSTER_ADMIN,
    DRAFT,
    IRB,
    RETURNED,
    SECRETARY,
    APPROVED,
    ACKNOWLEDGED,
    DISAPPROVED,
    REVIEWER,
    FOR_REVIEW,
    COMPLETED,
    REVIEWED,
    TAB_STUDY,
    TAB_SITE,
    TAB_COMMENT,
    TAB_AMENDMENT,
    TAB_REVIEWER_COMMENT,
    TAB_CONSOLIDATION,
    TAB_MEETINGARRANGE,
    TERMINATED,
} from 'utility/lookup';
import AcceptImg from 'assets/images/accept.png';
import RejectImg from 'assets/images/reject.png';
import SendIcon from '@material-ui/icons/Send';
import moment from 'moment';

const SFooter = styled.div`
    padding: 15px;
    display: flex;
    justify-content:right;
`;

const SHeaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 10px;
    padding: 15px;
`;

const CommentDialog = ({
    isShow = false,
    isEnableComment = true,
    maxWidth = 'sm',
    messages = [],
    comment = '',
    user = {},
    width = 500,
    onChangeComment = () => null,
    handleSave = () => null,
    onClose = () => null,
    onOpenChangeHistory = () => null,
    questionField,
    commentDetail,
    handleDelete,
    handleResolve,
    handleUpdate = () => null,
}) => {

    const [anchorEl, setAnchorEl] = useState(null);

    const dispatch = useDispatch();
    // const user = useSelector((state) => state.user);
    const [editComment, setEditComment] = useState('');
    const [editStatus, setEditStatus] = useState(null);
    // const [currentComment, setCurrentComment] = useState('');

    const handleEditComment = (message) => {
        setEditComment(message?.text);
        setEditStatus(true);
    }
    const onChangeEditComment = (e) => {
        setEditComment(e.target.value);
    }
    const handleConfirmEdit = () => {
        const arr = JSON.parse(commentDetail?.commentContext);
        const param = { ...commentDetail };
        arr[0].text = editComment;
        arr[0].lastUpdated = Date.now();
        param.commentContext = JSON.stringify(arr);

        const response = dispatch({ type: UPDATE_DRAFT_COMMENT, payload: param });
        setEditStatus(null);
    }

    const handleSaveComment = () => {
        if (!comment?.trim()) return;
        const obj = { ...commentDetail };
        const arr = JSON.parse(commentDetail?.commentContext);
        arr.push({
            text: comment,
            lastUpdated: Date.now(),
            updatedBy: `${user?.detail?.firstName} ${user?.detail?.surname}`,
            status: commentStatusEnum.PENDING
        })
        obj.commentContext = JSON.stringify(arr);
        handleSave({ param: obj, updateType: commentStatusEnum.PENDING });
        onChangeComment({ target: '' })
    }

    const onCustomClose = () => {
        onClose();
        setEditComment('');
        setEditStatus(null);
    }

    const onOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const deleteComment = () => {
        handleDelete(commentDetail, () => {
            handleClose();
        }, () => {
            onCustomClose();
        });
    }

    const resolveComment = () => {
        handleResolve(commentDetail, () => {
            handleClose();
        }, () => {
            onCustomClose();
        });
    }

    const handleRejectComment = () => {
        if (!comment?.trim()) return;
        const obj = { ...commentDetail };
        const arr = JSON.parse(commentDetail?.commentContext);
        arr.push({
            text: comment,
            lastUpdated: Date.now(),
            updatedBy: `${user?.detail?.firstName} ${user?.detail?.surname}`,
            status: commentStatusEnum.REJECTED
        })
        obj.commentContext = JSON.stringify(arr);
        handleUpdate({ param: obj, updateType: commentStatusEnum.REJECTED });
        onChangeComment({ target: '' })
    }

    const handleAcceptComment = () => {
        const obj = { ...commentDetail };
        const arr = JSON.parse(commentDetail?.commentContext);
        // arr[arr.length - 1].status = commentStatusEnum.ACCEPTED;
        arr.push({
            text: '',
            lastUpdated: Date.now(),
            updatedBy: `${user?.detail?.firstName} ${user?.detail?.surname}`,
            status: commentStatusEnum.ACCEPTED
        })
        obj.commentContext = JSON.stringify(arr);
        handleUpdate({ param: obj, updateType: commentStatusEnum.ACCEPTED });
    }

    const messageData = useMemo(() => {
        try {
            const arr = JSON.parse(commentDetail?.commentContext);
            return arr;
        } catch (error) {
            return []
        }
    }, [commentDetail])

    const renderBottom = () => {
        let renderComp = <SFooter>
                <CustomButton onClick={onCustomClose}>Close</CustomButton>
            </SFooter>;
        // if (commentDetail?.commentStatus === commentStatusEnum.RESOLVED) {
        //     return renderComp;
        // }
        if (user?.role !== APPLICANT && isEnableComment && commentDetail?.commentStatus !== commentStatusEnum.DRAFT) {
            renderComp = <InputComment
                comment={comment}
                user={user}
                onChangeComment={onChangeComment}
                onSubmit={handleSaveComment}
                submitIcon={<SendIcon />}
                placeholder='Reply to comment...'
            />
        }
        if (user?.role === APPLICANT) {
            renderComp = <InputComment
                comment={comment}
                user={user}
                onChangeComment={onChangeComment}
                onSubmit={handleRejectComment}
                submitIcon={<img src={RejectImg} style={{ cursor: 'pointer', width: '40px', height: '40px' }} />}
                placeholder='Reject comment'
            />
        }
        if (user?.role === APPLICANT && [commentStatusEnum.ACCEPTED, commentStatusEnum.REJECTED].includes(commentDetail?.commentStatus)) {
            renderComp = <SFooter>
                <CustomButton onClick={onCustomClose}>Close</CustomButton>
            </SFooter>
        }
        if (editStatus) {
            renderComp = <div style={{ display: 'flex', padding: '15px 15px 15px 0', position: 'relative', justifyContent: 'flex-end', gap: '5px' }}>
                <div style={{ display: 'flex', padding: '0 0 0 8px', gap: '15px' }}>
                    <CustomButton onClick={handleConfirmEdit}>Confirm</CustomButton>
                    <CustomButton type='cancel' onClick={() => {
                        setEditStatus(null);
                        setEditComment("");
                    }}>Cancel</CustomButton>
                </div>
            </div>
        }
        return renderComp;
    }

    return (
        <Dialog
            open={isShow}
            style={{ margin: 'auto' }}
            maxWidth={maxWidth}
        >
            <div
                style={{ minWidth: width }}
            >
                <SHeaderContainer>
                    {editStatus && <div style={{ marginRight: 'auto', fontSize: '18px', fontWeight: 500 }}>Edit Comment</div>}
                    {commentDetail?.commentStatus === commentStatusEnum.DRAFT &&
                        <MoreHorizIcon style={{ cursor: 'pointer' }} onClick={onOpenMenu} />
                    }
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={deleteComment}>Delete Comment</MenuItem>
                    </Menu>
                    {commentDetail?.commentStatus !== commentStatusEnum.DRAFT &&
                        <LaunchIcon style={{ cursor: 'pointer' }} onClick={() => onOpenChangeHistory(commentDetail?.id)} />
                    }
                    {(commentDetail?.commentStatus === commentStatusEnum.ACCEPTED || commentDetail?.commentStatus === commentStatusEnum.REJECTED) && 
                            user?.role !== APPLICANT && isEnableComment &&
                        <CheckCircleOutlineIcon style={{ cursor: 'pointer' }} onClick={resolveComment} />
                    }
                    <CloseIcon style={{ cursor: 'pointer' }} onClick={onCustomClose} />
                </SHeaderContainer>
                <Divider style={{ width: '100%' }} />
                {messageData?.length > 0 && messageData?.map((message, index) => (
                    <div key={message?.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: '8px' }}>
                        <CommentMessage
                            text={message?.text}
                            lastUpdated={message?.lastUpdated}
                            updatedBy={message?.updatedBy}
                            status={message?.status}
                            editStatus={editStatus}
                        />
                        {
                            commentDetail?.commentStatus === commentStatusEnum.DRAFT && user?.role !== APPLICANT && isEnableComment && !editStatus &&
                            <CustomButton onClick={() => handleEditComment(message)}>Edit</CustomButton>
                        }
                        {
                            commentDetail?.commentStatus !== commentStatusEnum.RESOLVED
                            && commentDetail?.commentStatus !== commentStatusEnum.ACCEPTED
                            && commentDetail?.commentStatus !== commentStatusEnum.REJECTED
                            && user?.role === APPLICANT
                            && index === (messageData?.length - 1)
                            &&
                            <img src={AcceptImg} onClick={handleAcceptComment}
                                style={{ cursor: 'pointer', padding: '0 8px 0 0', width: '40px', height: '40px', position: 'relative', left: '-12px' }} />
                        }
                    </div>
                ))}
                {
                    editStatus && <div style={{ display: 'flex', alignItems: 'center', padding: '8px 18px 8px 45px', position: 'relative', bottom: '15px' }}>
                        <CustomTextField
                            value={editComment}
                            onChange={onChangeEditComment}
                            placeholder=""
                            isTextArea
                        />
                    </div>
                }
                <Divider style={{ width: '100%' }} />
                {/* {
                    commentDetail?.commentStatus === commentStatusEnum.RESOLVED || commentDetail?.commentStatus === commentStatusEnum.DRAFT ?
                        <SFooter>
                            <CustomButton onClick={onCustomClose}>Close</CustomButton>
                        </SFooter>
                        :
                        <InputComment
                            comment={comment}
                            user={user}
                            onChangeComment={onChangeComment}
                            onSubmit={handleSave}
                        />
                } */}
                {
                    renderBottom()
                }
            </div>
        </Dialog>
    );
};

const CommentDialogViewOnly = ({
    isShow = false,
    maxWidth = 'sm',
    messages = [],
    onClose = () => null,
    width = 400,
}) => {
    return (
        <Dialog
            open={isShow}
            style={{ margin: 'auto' }}
            maxWidth={maxWidth}
        >
            <div
                style={{ minWidth: width }}
            >
                <SHeaderContainer>
                    <CloseIcon style={{ cursor: 'pointer' }} onClick={onClose} />
                </SHeaderContainer>
                <Divider style={{ width: '100%' }} />
                {messages.map(message => (
                    <div key={message?.id}>
                        <CommentMessage text={message?.text} lastUpdated={message?.lastUpdated} updatedBy={message?.updatedBy} status={message?.status} />
                    </div>
                ))}
                <Divider style={{ width: '100%' }} />
                <SFooter>
                    <CustomButton onClick={onClose}>Close</CustomButton>
                </SFooter>
            </div>
        </Dialog>
    );
};

export {
    CommentDialog,
    CommentDialogViewOnly
};
